import {ActionBuilder} from "co-redux-builders";

export default ActionBuilder.build({
    setUserName: (username: string) => ({username}),
    setPassword: (password: string) => ({password}),
    setError: (error: string) => ({error}),
});